export default {
  letsKeepInTouch: {
    en: `Let's keep in touch`,
  },
  receiveSpecialOffers: {
    en: 'Receive special offers and always stay in touch.',
  },
  enterEmailAddress: {
    en: 'Enter email address',
  },
  thanksForSubscribing: {
    en: 'Thanks for subscribing to our newsletter!',
  },
  errorOccurred: {
    en: 'An error occurred.<br />Please reload the page.',
  },

  label: {
    en: 'Email',
  },
  submit: {
    en: 'Submit email',
  },
}
